module.exports = __webpack_public_path__ + "static/img/shui2.53b301c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/shui2.jpg
// module id = hBc4
// module chunks = 0